import { SideImage } from '../../components/SideImage';
import { GuestDetailsContentPanel } from '../../composites/GuestDetailsContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { GuestDetailsTemplateProps } from './GuestDetailsTemplate.types';

export function GuestDetailsTemplate({
  imageUrl,
  imageAlt = '',
  ...panelProps
}: GuestDetailsTemplateProps) {
  return (
    <SplitLayout
      leftWidth="45%"
      contentMaxWidth="660px"
      hideLeftOnMobile
      left={<SideImage src={imageUrl ?? undefined} alt={imageAlt} sticky />}
      right={<GuestDetailsContentPanel {...panelProps} />}
    />
  );
}
